const workercode = () => {

  self.onmessage = (e) => {
    let reader = new FileReader();
    reader.readAsDataURL(e.data);
    reader.onload = () => {
      self.postMessage(reader.result)
    }
  }

};

let code = workercode.toString();
code = code.substring(code.indexOf("{")+1, code.lastIndexOf("}"));

const blob = new Blob([code], {type: "application/javascript"});
const worker_script = URL.createObjectURL(blob);

export default worker_script;


// WEBPACK FOOTER //
// ./src/components/MyProfile/worker.js